// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/img/backgroud-bosch.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    height: 91dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
}

.container-exp {
    min-width: 650px;
    min-height: 250px;
    background-color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.img-alert {
    width: 50px;
    height: 50px;
    margin-bottom: 5px;
}

.text-exp {
    color: #007BC0;
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 20px;
}

.button-container {
    margin-top: 30px;
}

.text-apli {
    margin-top: 25px;
    text-align: center;
}

.line {
    color: white;
    margin-top: 1px #007BC0;
    width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/LoginExpirado.css"],"names":[],"mappings":"AAAA;IACI,yDAA4D;IAC5D,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;AAChB","sourcesContent":[".login-container {\n    background-image: url('/src/assets/img/backgroud-bosch.png');\n    background-size: cover;\n    background-position: center;\n    height: 91dvh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow-y: hidden;\n}\n\n.container-exp {\n    min-width: 650px;\n    min-height: 250px;\n    background-color: white;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n}\n\n.img-alert {\n    width: 50px;\n    height: 50px;\n    margin-bottom: 5px;\n}\n\n.text-exp {\n    color: #007BC0;\n    font-weight: 700;\n    font-size: 18px;\n    margin-bottom: 20px;\n}\n\n.button-container {\n    margin-top: 30px;\n}\n\n.text-apli {\n    margin-top: 25px;\n    text-align: center;\n}\n\n.line {\n    color: white;\n    margin-top: 1px #007BC0;\n    width: 400px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
